import React from 'react';

import classes from './ContactPage.module.scss';

const ContactPage = () => {
    return <div className={classes.Right}>
        <h1>Contact Page</h1>
        <p><span>Katedra Matematyki</span></p>
        <p>Uniwersytetu Jana Kochanowskiego w Kielcach</p>
        <p>ul. Uniwersytecka 7, 25-406 Kielce, Poland</p>
        <p>e-mail: cmk2020@ujk.edu.pl</p>
    </div>
}

export default ContactPage;